<!--任务确认-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button
icon="el-icon-download"
@click="exportConfig()"
            >有效人天导出</el-button
          >
          <el-button
icon="el-icon-download"
@click="exportDataList"
            >人天差异统计</el-button
          >
          <el-button
          icon="el-icon-download"
          @click="exportProjectDataList"
                      >项目总览统计报表</el-button
                    >
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{ trigger: 'click', mode: 'cell' }"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-circle-check"
            @click="taskConfirm(scope.row)"
          ></el-button>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-circle-close"
            v-if="scope.row.accomplishCondition === 'Y'"
            @click="refuseTask(scope.row)"
          ></el-button>
        </template>
      </edit-data-table>
      <drag-dialog
        append-to-body
        :show.sync="exportDialogVisible"
        :title="exportTitle"
        :enableDrag="true"
        width="800px"
        :loading="dialogLoading"
        @close="exportDialogVisible = false"
      >
      <font color="red">导出范围：{{exportRemark}}</font>
        <dynamic-form
          :formConfig="exportFormConfig"
          v-model="exportForm"
          labelWidth="120px"
          @submit="exportExcel"
          :loading="dialogLoading"
          @cancelForm="exportDialogVisible = false"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>

      <drag-dialog
        v-if="hackReset"
        append-to-body
        :show.sync="dialogVisible"
        title="任务确认"
        :enableDrag="true"
        width="800px"
        @close="dialogVisible = false"
      >
        <dynamic-form
          :formConfig="formConfig"
          v-model="form"
          labelWidth="120px"
          @submit="submit"
          @cancelForm="dialogVisible = false"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import "@/components/dynamic-form";
import DynamicSearch from "@/components/DynamicSearch";
import DragDialog from "@/components/DragDialog";
import DataTableMixin from "@/mixins/DataTableMixin";
import { parseTime } from "@/utils";
import { exportExcel, exportDataExcel, exportProjectDataExcel} from "@/api/bill/taskReport";
import { taskVerify, taskRefuse } from '@/api/bill/assignment'
import { deepClone } from '../../../components/edit-table/src/util';
export default {
  name: "TaskComfirm",
  components: {
    DynamicSearch, DragDialog
  },
  mixins: [DataTableMixin],
  data () {
    return {
      exportTitle: null,
      exportRemark: null,
      hackReset: true,
      dialogLoading: false,
      tableHead: [
        {
          label: "项目名称",
          prop: "project.name",
          query: {
            type: "input"
          }
        },
         {
          label: "项目编号",
          prop: "projectCode",
        },
        {
          label: "项目经理",
          prop: "projectManagerName",
        },
        {
          label: "终端客户",
          prop: "customerMain",
          align: "center",
          formatter: (cellVal, row) => {
            if (row && row.project && row.project.customer) {
              return row.project.customer.name
            } return ''
          }
        },
        {
          label: "阶段名称",
          prop: "milestoneName",
        },
        {
          label: "节点名称",
          prop: "nodeEntity.name",
          query: {
            type: "input"
          }
        },
        {
          label: "任务人",
          prop: "taskReceiverPerson.name",
          query: {
            type: "input"
          }
        },
        {
          label: "任务",
          prop: "taskContent",
        },
        {
          label: "任务开始时间",
          prop: "plannedStartTime",
          formatter: this.formatter
        },
        {
          label: "任务结束时间",
          prop: "plannedEndTime",
          formatter: this.formatter
        },
        {
          label: "汇报内容",
          prop: "reportContent",
        },
        {
          label: "汇报时间",
          prop: "reportDate",
        },
        {
          label: "计划人天",
          prop: "disposableHumanNature"
        },
        {
          label: "汇报人天",
          prop: "reportDay"
        },
        {
          label: "成本人天",
          prop: "verifyHumanNature"
        },
      ],
      dialogVisible: false,
      exportDialogVisible: false,
      request: null,
      form: {},
      exportForm: {
        startTime: '',
        endTime: ''
      },
      exportFormConfig: {
        formItemList: [
          {
            span: 12,
            type: "databox",
            key: "projectNumber",
            label: "项目号",
            placeholder: "请选择项目",
            value: "",
            props: {
              label: "name",
              value: "id"
            },
            url: "/bsProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              },
            ],
            multiple: false,
          },
          {
            span: 12,
            type: "databox",
            key: "customerId",
            label: "终端客户",
            placeholder: "请选择终端客户",
            value: "",
            props: {
              label: "name",
              value: "id"
            },
            url: "/customer",
            tableColumn: [
              {
                property: "code",
                label: "客户编码",
              },
              {
                property: "name",
                label: "客户名称",
                query: {
                  type: "input"
                }
              },
            ],
            multiple: false,
          },
          {
            span: 24,
            label: '选择时间段',
            key: 'time',
            type: 'date',
            subtype: 'daterange',
            viewFormat: "yyyy-MM-dd",
          },
        ]
      },
      formConfig: {
        formItemList: [
          {
            label: '节点描述',
            key: 'nodeName',
            type: 'input',
            span: 12,
            disabled: true
          },
          {
            label: '任务名称',
            key: 'name',
            type: 'input',
            span: 12,
            disabled: true
          },
          {
            span: 12,
            type: "input",
            key: "taskContent",
            label: "任务内容",
            subtype: 'textarea',
            placeholder: "请输入任务内容",
            disabled: true
          },
          {
            span: 12,
            type: "input",
            key: "reportContent",
            label: "汇报内容",
            subtype: 'textarea',
            placeholder: "请输入任务内容",
            disabled: true
          },
          {
            span: 12,
            label: '计划完成日期',
            key: 'plannedEndTime',
            type: 'date',
            disabled: true
          },
          {
            span: 12,
            label: '可支配人天',
            key: 'disposableHumanNature',
            type: 'input',
            subtype: 'number',
            disabled: true
          },
          {
            span: 12,
            label: '剩余人天',
            key: 'taskDayDiff',
            type: 'input',
            subtype: 'number',
            disabled: true
          },
          {
            span: 12,
            label: '累计确认人天',
            key: 'sumVerifyNature',
            type: 'input',
            subtype: 'number',
            disabled: true
          },
          {
            span: 12,
            label: '任务是否完成',
            key: 'accomplishCondition',
            type: "switch",
          },
          {
            span: 12,
            label: '本次汇报人天',
            key: 'reportDay',
            type: 'input',
            subtype: 'number',
            disabled: true
          },
          {
            span: 12,
            label: '本次确认人天',
            key: 'verifyHumanNature',
            type: 'number',
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          }, {
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            span: 12,
            type: "select",
            label: "项目角色",
            button: false,
            border: true,
            key: "projectRole",
            autoSelectFirst: true,
            optionsUrl: "",
          },

        ]
      },
    };
  },
  created () {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  watch: {
    'exportForm.time': {
      handler (val, oldVal) {
        if (val) {
          const startTime = this.formatter(val[0]);
          const endTime = this.formatter(val[1])
          this.exportForm.startTime = startTime
          this.exportForm.endTime = endTime
        } else {
          this.exportForm.startTime = ''
          this.exportForm.endTime = ''
        }
      }
    },
  },
  methods: {
    formatter (val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    dataTableBeforeInit () {
      this._url = "/taskVerify";
      const params = { page: this.page, size: this.offset, }
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch () { },
    exportConfig () {
      this.exportDialogVisible = true
      this.request = exportExcel
      this.exportTitle = "有效人天导出"
      this.exportRemark = "任务汇报时间在此时间内的数据"
    },
    exportDataList () {
      this.exportDialogVisible = true
      this.request = exportDataExcel
      this.exportRemark = "任务汇报时间在此时间内的数据"
      this.exportTitle = "人天差异统计"
    },
    exportProjectDataList () {
      this.exportDialogVisible = true
      this.request = exportProjectDataExcel
      this.exportTitle = "项目总览统计报表"
      this.exportRemark = "项目阶段预计开始时间或预计结束时间在此时间范围内的数据(不选则导出全部)"
    },
    // 任务退回
    refuseTask (row) {
      // this.form.id = row.id
      // this.form.nodeName = row.nodeEntity.name;
      // this.form.taskContent = row.taskContent
      // this.form.plannedEndTime = row.plannedEndTime
      // this.form.disposableHumanNature = row.disposableHumanNature
      // this.form.reportId = row.reportId
      const params = {
        id: row.id,
        reportId: row.reportId
      }
      this.$confirm('是否回退?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        taskRefuse(params).then(res => {
          if (res.code === 200) {
            this.dataTableInit();
            this.$notify({ title: '汇报回退成功！', type: 'success', duration: 2500 })
          }
        })
      })
    },
    // 任务确认
    taskConfirm (row) {
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true
      });

      // for (var i = 0; i < this.formConfig.formItemList.length; i++) {
      //   if (this.formConfig.formItemList[i].key == "projectRole") {
      //     this.formConfig.formItemList[i].optionsUrl = "/taskVerify/taskVerifySelectRoleUrl/" + row.id;
      //   }
      // }
      this.form.name = row.name // 任务名称
      this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(i => i.key === 'projectRole')], 'optionsUrl', "/taskVerify/taskVerifySelectRoleUrl/" + row.id)
      this.form.projectRole = null;
      this.form.projectRole = null;
      this.form.id = row.id
      this.form.reportDay = row.reportDay
      this.form.nodeName = row.nodeEntity.name;
      this.form.taskContent = row.taskContent
      this.form.plannedEndTime = row.plannedEndTime
      this.form.disposableHumanNature = row.disposableHumanNature
      this.form.reportContent = row.reportContent
      this.form.taskDayDiff = row.taskDayDiff
      this.form.sumVerifyNature = row.sumVerifyNature
      this.form.reportId = row.reportId
      if (row.accomplishCondition === 'Y') {
        this.form.accomplishCondition =  true
      } else {
        this.form.accomplishCondition = false
      }
      // this.$set(this.formConfig.formItemList[5],'value',new Date().getTime());
      this.dialogVisible = true;
      this.form.verifyHumanNature = null;
    },
    // 任务确认提交
    submit () {
      // if (parseFloat(this.form.verifyHumanNature) > parseFloat(this.form.reportDay)) {
      //   this.$notify({ title: '确认人天不可超过汇报人天', type: 'error', duration: 2500 })
      //   return;
      // }
      let msg = ''
      const form = deepClone(this.form)
      form.accomplishCondition = form.accomplishCondition ? 'Y' : 'N'
      if (parseFloat(form.verifyHumanNature) > parseFloat(form.taskDayDiff)) {
        const message = '本次确认将超出任务可支配人天，是否确认？'
        const accomplishMessage = '本次确认将超出任务可支配人天，并确认是否已完成任务!'
        this.$confirm(form.accomplishCondition === 'Y' ? accomplishMessage : message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.saveForm(form)
        })
      } else {
        if (parseFloat(form.verifyHumanNature) !== parseFloat(form.reportDay)) {
          msg = '确认人天和汇报人天有差异，并确认是否已完成任务!'
        }
        this.$confirm(msg || '请确认是否已完成任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveForm(form)
        })
      }
    },
    saveForm(form) {
      this.dialogVisible = false;
      taskVerify(form,form.reportId).then(res => {
        if (res.code === 200) {
          this.dataTableInit();
          this.$notify({ title: '操作成功！', type: 'success', duration: 2500 })
        }
      })
    },
    getWeekEndDay (val) {
      let nd = val;
      nd = nd.valueOf();
      nd = nd + 6 * 24 * 60 * 60 * 1000;
      nd = new Date(nd);
      var y = nd.getFullYear();
      var m = nd.getMonth() + 1;
      var d = nd.getDate();
      if (m <= 9) m = "0" + m;
      if (d <= 9) d = "0" + d;
      var cdate = y + "-" + m + "-" + d;
      return cdate;
    },
    exportExcel () {
      this.dialogLoading = true
      const customerId = this.exportForm.customerId ? this.exportForm.customerId.id : ''
      const code = this.exportForm.projectNumber ? this.exportForm.projectNumber.code : ''
      this.request(this.exportForm.startTime, this.exportForm.endTime,customerId,code);
      this.dialogLoading = false
    }
  }
};
</script>

<style scoped lang="scss">
</style>
